import {Tenant} from './tenant';
import {Organization} from './organization';

export class Sequence {
  uuid: string;
  name: string;
  tenant: Tenant;
  organization: Organization;
  currentStage: string;
  status: SequenceState;
  scheduledSequenceConfig: ScheduledSequenceConfig;
  recurrentSequenceConfig: RecurrentSequenceConfig;
  nextActivation?: number;
  disabled: boolean;
  configuration?: any;
}

export class SequenceSubscriptions {
  emails: string[];
}

export enum SequenceState {
  NOT_COMPLETED = 'NOT_COMPLETED',
  EXECUTING = 'EXECUTING',
  COMPLETED = 'COMPLETED',
  WAITING = 'WAITING',
  FAILED = 'FAILED',
  RESTORED = 'RESTORED'
}

export class RecurrentSequenceConfig {
  recurrentTime: number;
}

export class ScheduledSequenceConfig {
  startHour: number;
  startMinute: number;
  startDate: number;
  endDate: number;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}
